import { render, staticRenderFns } from "./ProjectBuilder.vue?vue&type=template&id=77dab9ff"
import script from "./ProjectBuilder.vue?vue&type=script&lang=js"
export * from "./ProjectBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports